import { Bot, Send, ShieldCheck, Users } from 'lucide-react';
import type { ProductFeature, OtpTemplateShape } from '@/services/products.service';

export const FEATURES: Array<{ id: ProductFeature; label: string; hint: string; icon: React.ReactNode }> = [
  { id: 'otp',           label: 'Login OTP',       hint: 'The app sends login codes through this company\'s WhatsApp number.', icon: <ShieldCheck size={14} /> },
  { id: 'transactional', label: 'Transactional',   hint: 'Template messages the app triggers: receipts, reminders.',           icon: <Send size={14} /> },
  { id: 'daily_mcq',     label: 'Daily MCQ push',  hint: 'Nightly question to opted-in users (PrepFCPS).',                     icon: <Bot size={14} /> },
  { id: 'contact_sync',  label: 'Contact sync',    hint: 'App users are pushed here as contacts for campaigns.',              icon: <Users size={14} /> },
];

export const SHAPES: Array<{ id: OtpTemplateShape; label: string; example: string }> = [
  { id: 'code_only',                label: 'Code only',                    example: 'Body {{1}} = code. No button.' },
  { id: 'code_plus_url_button',     label: 'Code + copy button',           example: 'Body {{1}} = code, URL button carries the code. Meta\'s standard authentication layout.' },
  { id: 'code_purpose_url_button',  label: 'Code + purpose + copy button', example: 'Body {{1}} = code, {{2}} = purpose ("Login"), URL button carries the code.' },
];

export const relative = (iso?: string | null) => {
  if (!iso) return 'never';
  const m = Math.floor((Date.now() - new Date(iso).getTime()) / 60000);
  if (m < 1) return 'just now';
  if (m < 60) return `${m} min ago`;
  const h = Math.floor(m / 60); if (h < 24) return `${h}h ago`;
  return `${Math.floor(h / 24)}d ago`;
};

export function Spark({ data, width = 120, height = 28 }: { data: number[]; width?: number; height?: number }) {
  if (!data?.length) return null;
  const max = Math.max(...data, 1), step = width / (data.length - 1);
  const pts = data.map((v, i) => `${(i * step).toFixed(1)},${(height - 2 - (v / max) * (height - 4)).toFixed(1)}`).join(' ');
  const total = data.reduce((a, b) => a + b, 0);
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} aria-label={`${total} messages in 30 days`}>
      <polyline points={pts} fill="none" stroke="var(--color-primary)" strokeWidth={1.5} strokeLinejoin="round" strokeLinecap="round" opacity={total ? 1 : 0.3} />
    </svg>
  );
}

export const initials = (name: string) => name.trim().split(/\s+/).slice(0, 2).map((w) => w[0]?.toUpperCase() ?? '').join('') || '·';
